import styled, { css } from 'styled-components';
import { SubmitButton } from '@bookingForm/styles/buttons';
import MediaSizes from '@widgets/shared/MediaSizes';
import Styles from '@widgets/GenericBookings/components/SessionSelector/styles';
export const SubLabel = styled.span `
  font: var(--paragraph-font);
  color: var(--text);
  margin-bottom: 0;
  margin-left: 1rem;

  ${({ theme: { formSubLabel } }) => formSubLabel}
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    display: block;
    width: 100%;
    margin-left: 0;
    margin-top: 0.5rem;
  }
`;
export const SelectedOptionWrapper = styled.div `
  position: relative;
`;
const LoadingWrapper = styled.div `
  height: 41rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    height: 51.6rem;
  }
`;
export const Label = styled.label `
  appearance: none;
  -webkit-appearance: none;
  font-family: MouseMemoirs, Helvetica, Arial, sans-serif;
  background-color: transparent;
  border: none;
  color: white;
  opacity: 1;
  font-size: 2.8rem;
  line-height: 3.4rem;
  transition: all .2s linear;
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    ${({ hasSublabel }) => {
    if (hasSublabel) {
        return css `
          & + ${Styles.Wrapper} ${Styles.SwiperNavigation} {
            top: -6.5rem;
          }
        `;
    }
}}
  }
}

  ${({ theme: { formLabel }, isHidden, hasSublabel }) => css `
    ${formLabel && formLabel}
    ${isHidden && css `
      background-color: transparent; // load baring background-color, display none isn't working else????
      display: none;
    `}
  `}
  
  svg {
    margin-right: 1rem;
  }

  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    flex-wrap: wrap;
  }
`;
export const Group = styled.div `
  display: block;
  position: relative;
  width: 100%;
  ${({ theme: { formGroup } }) => formGroup}

  ${({ isCalendar }) => isCalendar && css `
    max-width: 82rem;
  `}

  ${({ isWide }) => isWide && css `
    @media screen and (min-width: 992px) {
      max-width: 100% !important;
    }
  `}

  ${({ half }) => half && css `
    ${({ theme: { halfFormGroup } }) => halfFormGroup}
  `}
`;
export const GroupWithCalendar = styled.div `
    ${({ isOpen }) => isOpen && css `
      ${Group} {
        max-width: 82rem;
      }
      
      ${SelectedOptionWrapper} {
        z-index: 5;
      }
    `}
`;
export const Fields = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  ${({ theme: { formFields } }) => formFields}
  
  ${LoadingWrapper} {
    position: absolute;
    z-index: 15;
    height: calc(100% + 4rem);
    width: calc(100% + 4rem);
    top: -2rem;
    
    // offsetting additional height from the key at bottom
    .form--winter-wonderland.form--loading.step--calendar & {
      @media screen and (max-width: ${MediaSizes.SM_MAX}px) {
        height: calc(100% + 20rem);
        top: -2rem;
      }
    }
    
    .form--winter-wonderland & {
      .h6 {
        color: #000;
      }
    }
    
    left: -2rem;
    background-color: var(--loading-bg, rgba(255, 255, 255, 0.7));
  }
`;
export const Submit = styled.aside `
  ${({ theme: { submitWrapper } }) => submitWrapper}
  
  ${SubmitButton} {
    margin-top: 1rem;
  }
`;
const Wrapper = styled.form `
  padding-left: 2rem;
  padding-right: 2rem;
  overflow: hidden;
  position: relative;

  ${({ theme: { formWrapper } }) => formWrapper}
  
  &.step--calendar {
    ${({ theme: { formStepCalendar } }) => formStepCalendar}
  }

  &.step--diy-day-tickets {
    ${({ theme: { formDiyDayTickets } }) => formDiyDayTickets}
  }
  
  &.step--attendees {
    ${({ theme: { formStepAttendees } }) => formStepAttendees}
  }
  
  // step for activities, only exists on DIY day tickets.
  &.step--activities {
    ${({ theme: { formStepActivities } }) => formStepActivities}
  }

  &.step--sessions {
    ${({ theme: { formStepSessions } }) => formStepSessions}
  }
  
  // TODO: move all the below into new theme options...

  ${({ isLastStep, layout, labelsShown, step, }) => css `
    // New Calendar stylings 
    ${(layout && layout === 'rework') && css `
      max-width: 86rem;
      margin: 0 auto;
      overflow: visible;
    `}

    // override the width if we are on the calendar 
    ${(layout && layout === 'rework' && css `
      &.step--calendar {
        max-width: 65rem;

        // ${SelectedOptionWrapper} {
        //   max-width: 40rem;
        //   margin: 0 auto;
        // }

        @media screen and (max-width: ${MediaSizes.MD}px) {
          max-width: 100%;
        }
      }
    `)}

      // override the width if we are on the calendar 
    // ${(layout && layout === 'rework' && css `
    //   &.form--diy-day-tickets {
    //     ${SelectedOptionWrapper} {
    //       max-width: 40rem;
    //       margin: 0 auto;
    //       position: relative;
    //     }
    //   }
    // `)}
    
    ${(layout && layout === 'rework' && css `
      ${SelectedOptionWrapper} {
        width: 100%;
        max-width: 40rem;
        margin: 0 auto;
        position: relative;
      }
    `)}

    
    
    // override the width if we are on the visitors step
   ${(layout && (layout === 'rework' || layout === 'winter-wonderland')) && css `
     &.step--attendees {
       max-width: 44rem;

       @media screen and (max-width: ${MediaSizes.MD}px) {
         max-width: 100%;
       }
     }
   `}

    // override the width if we are on the activities step
    ${(layout && layout === 'rework') && css `
     &.step--activities {
       max-width: 65rem;

       // ${SelectedOptionWrapper} {
       //   max-width: 40rem;
       //   margin: 0 auto;
       //   position: relative;
       // }

       @media screen and (max-width: ${MediaSizes.MD}px) {
         max-width: 100%;
       }
     }
   `}

    // override the width if we are on the sessions step
    ${(layout && (layout === 'rework' || layout === 'winter-wonderland')) && css `
     &.step--sessions {
       max-width: 86rem;

       // ${SelectedOptionWrapper} {
       //   max-width: 40rem;
       //   margin: 0 auto;
       // }

       @media screen and (max-width: ${MediaSizes.MD}px) {
         max-width: 100%;
       }
     }
   `}
    
    ${(layout && (layout === 'vertical' || layout === 'product')) && css `
      max-width: 39.5rem;
      margin: 0 auto;
      
      ${Submit}{
        margin-top: 2rem;
      }

      @media screen and (max-width: ${MediaSizes.MD}px) {
        max-width: 100%;
      }
    `}

    ${(layout && layout === 'horizontal') && css `
      ${Submit}{
        @media screen and (min-width: 992px) {
          flex: 0 0 36rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          
          ${labelsShown && css `
            padding-top: 4.3rem;
            padding-bottom: 4rem;
          `}
        }
  
        @media screen and (min-width: 992px) and (max-width: 1200px) {
          flex: 0 0 30rem;
        }
  
        @media screen and (max-width: 991px) {
          max-width: 39.5rem;
          margin: 2rem auto 0;
        }
      }
      @media screen and (min-width: 992px) {
        ${Group} {
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      
      ${isLastStep && css `
        @media screen and (min-width: 992px) {
          display: flex !important;
          align-items: flex-start;
          max-width: 126rem;
          margin: 0 auto -2rem;
          
          ${isLastStep && css `
            justify-content: space-between;
          `}
  
          ${Fields} {
            display: flex;
            flex: 1 1 calc(100% - 42rem);
            max-width: calc(100% - 42rem);
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
  
            ${Group} {
              flex: 1 0 auto;
              max-width: calc(50% - 1.5rem);
              margin-bottom: 2rem;

              &:last-child {
                margin-bottom: 0;
              }
            }
  
            ${Group} + ${Group} {
              margin-top: 0 !important;
            }
          }
        }

        @media screen and (min-width: 992px) and (max-width: 1200px) {
          ${Fields} {
            flex: 1 1 calc(100% - 34rem);
            max-width: calc(100% - 34rem);
          }
        }
      `}
    `}
  `}
`;
export const Notices = styled.div `
  position: fixed;
  padding: 0 2rem;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 11;
  width: 100%;
  max-width: 86rem;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px){
    bottom: 9rem;
  }
`;
const BundleWrapper = styled.div `
  display: flex;
  justify-content: center;
  margin-bottom: 3rem;
  width: 100%;
  
  .tag {
    display: flex;
    align-content: center;
  }
  
  .blank-btn {
    line-height: 0;
    margin-left: 0.5rem;
    
    svg {
      width: 0.8rem;
      height: 0.8rem;
      min-width: 0.8rem;
      min-height: 0.8rem;
      fill: currentColor;
      position: relative;
      bottom: 0.1rem;
    }
  }
`;
export default {
    Submit,
    Label,
    Group,
    Fields,
    SelectedOptionWrapper,
    Wrapper,
    LoadingWrapper,
    Notices,
    BundleWrapper,
};
